import { ListHabitatsQuery } from '@akin-home/amplify';
import { deleteHabitatMutation } from '@akin-home/habitats/frontend';
import { useMutation, useQueryClient } from 'react-query';
import { habitatQueryKeys } from './index';

// type CachedHabitat = NonNullable<GetHabitatQuery['getHabitat']>;
type CachedHabitats = NonNullable<ListHabitatsQuery['listHabitats']>['items'];

/** Handles the serverside deleting of habitats */
export const useDeleteHabitatMutation = () => {
  const client = useQueryClient();

  return useMutation((id: string) => deleteHabitatMutation({ input: { id } }), {
    onSuccess: (_, id) => {
      client.setQueriesData<CachedHabitats | undefined>(
        habitatQueryKeys.lists(),
        (habitats) => habitats?.filter((habitat) => habitat?.id !== id)
      );
      client.removeQueries(habitatQueryKeys.detail(id));
      client.invalidateQueries(habitatQueryKeys.all_pages());
    },
  });
};

export const useDeleteHabitat = () => {
  const del = useDeleteHabitatMutation();
  return (id: string) => del.mutateAsync(id);
};
